// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.t-vue-lbtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 20px;\n    padding: 0;\n    margin-right: 0px;\n    z-index: auto;\n    pointer-events: all;\n    cursor: pointer;\n    border-radius: 3px;\n    color: inherit;\n}\n.t-vue-lbtn svg {\n    width: 12px;\n    height: 12px;\n}\n.t-vue-lbtn:hover {\n    background: rgba(209, 212, 220, 0.4);\n}\n", ""]);
// Exports
module.exports = exports;
